import { createService } from '@/helpers/hasura'

import gql from 'graphql-tag'

import { FileFragment } from '@/helpers/api/fragments'

const output = `
    ...File
`

const fragments = gql`
  ${FileFragment}
`

const allowedFields = [
  'user_id',
  'file_size',
  'file_name',
  'file_content_type',
  'key',
  'bucket_name',
  'customer_id',
  'uploaded_at',
  'is_temporary'
]

export default config => {
  const service = createService({
    ...config,
    table: 'file_uploads',
    defaultPageSize: 25,
    defaultOrderBy: [{ file_name: 'asc' }],
    defaultSearchBy: null,
    defaultFilters: [],
    defaultOutput: output,
    defaultFragments: fragments,
    allowedFields
  })

  return {
    ...service,
    upload_url: async payload => {
      const { client } = config
      const {
        file_name,
        file_size,
        file_content_type = 'application/octet-stream',
        key
      } = payload

      const mutation = gql`
        mutation ($file: UploadInput!) {
          item: upload_url(file: $file) {
            url
            file_id
          }
        }
      `

      const { data } = await client.mutate({
        mutation,
        variables: {
          file: {
            file_name,
            file_size,
            file_content_type,
            key
          }
        }
      })

      return data.item
    },
    download_url: async payload => {
      const { client } = config

      const { file_id } = payload

      const query = gql`
        query ($file_id: uuid!, $expires: Int) {
          item: download_url(file_id: $file_id) {
            url
          }
        }
      `

      const { data } = await client.query({
        fetchPolicy: 'network-only',
        query,
        variables: {
          file_id
        }
      })

      return data.item
    }
  }
}
